import MobileOppoScroll from "./MobileOppoScroll";
import OppoScroll from "./ui/oppo-scroll";

// Dans votre composant parent
const ResponsiveOppoScroll = () => {
    return (
        <>
            <div className="hidden lg:block">
                <OppoScroll />
            </div>
            <div className="block lg:hidden">
                <MobileOppoScroll />
            </div>
        </>
    );
};

export default ResponsiveOppoScroll;